import {schema} from 'normalizr'
import {articleSchema} from './article'
import {askSchema} from './ask'
import {channelSchema} from './channel'
import {organizationAnnouncementSchema, organizationDepartmentSchema, organizationSchema} from './organization'
import {pollSchema} from './poll'
import {postSchema} from './post'
import {userSchema} from './user'
import {widgetSchema} from './widget'
import {godwordsSchema} from "../godwords";
import {userCheckinSchema} from "../event";
import {courseClassAnnouncementSchema} from "../course";

export const feedContainerSchema = new schema.Union(
    {
        user: userSchema,
        channel: channelSchema,
        organization: organizationSchema,
        organization_department: organizationDepartmentSchema,
    },
    '_type'
)

export const feedContentSchema = new schema.Union(
    {
        post: postSchema,
        ask: askSchema,
        poll_question: pollSchema,
        article: articleSchema,
        organization_announcement: organizationAnnouncementSchema,
        course_class_announcement: courseClassAnnouncementSchema,
        widget: widgetSchema,
    },
    '_type'
)

export const getContentSchema = (type) => {
    switch (type) {
        case "post":
            return postSchema;
        case "ask":
            return askSchema;
        case "poll_question":
            return pollSchema;
        case "article":
            return articleSchema;
        case "god_word":
            return godwordsSchema;
        case "user_checkin":
            return userCheckinSchema;
        case "organization_announcement":
            return organizationAnnouncementSchema;
        case "course_class_announcement":
            return courseClassAnnouncementSchema;
        default:
    }
    return postSchema;
}

export const feedSchema = new schema.Entity(
    'feeds',
    {
        container: feedContainerSchema,
        content: feedContentSchema,
    },
    {
        idAttribute: 'id',
    }
)

export const recommendationUsersFeedSchema = new schema.Entity(
    'feeds',
    {
        content: [userSchema],
    },
    {
        idAttribute: 'id',
    }
)
export const recommendationChannelsFeedSchema = new schema.Entity(
    'feeds',
    {
        content: [channelSchema],
    },
    {
        idAttribute: 'id',
    }
)


export const homeFeed = new schema.Union(
    {
        feed: feedSchema,
        'recommendation-channels': recommendationChannelsFeedSchema,
        'recommendation-users': recommendationUsersFeedSchema
    },
    (value) => {
        switch (value.action) {
            case 'recommendation-channels':
                return 'recommendation-channels'
            case 'recommendation-users':
                return 'recommendation-users'
            default:
                return 'feed'
        }
    }
)
